// extracted by mini-css-extract-plugin
module.exports = {"container":"inbox_container__KtCww","gridContainer":"inbox_gridContainer__19PrE","items":"inbox_items__2jakm","item":"inbox_item__GpSdD","content":"inbox_content__2Z9C1"};